import {
    deleteItem,
    getList,
    patchItem,
    postItem,
    putItem
} from "./utils/entity-network-requests"

import { stakeholderBaseUrl } from "./utils/network-config"

const getEntityName = stakeholderID => {
    return `stakeholder/${stakeholderID}/role`
}

export const getRoleList = (token, parameters) => {
    const entityName = getEntityName(parameters.get("stakeholderID"))
    return getList(entityName, parameters, token, stakeholderBaseUrl)
}

export const putRoleItem = (token, stakeholderID, role) => {
    const entityName = getEntityName(stakeholderID)
    return putItem(entityName, role.id, role, token, stakeholderBaseUrl)
}

export const patchRoleItem = (token, stakeholderID, role) => {
    const entityName = getEntityName(stakeholderID)
    return patchItem(entityName, role.id, role, token, stakeholderBaseUrl)
}

export const postRoleItem = (token, stakeholderID, role) => {
    const entityName = getEntityName(stakeholderID)
    return postItem(entityName, role, token, stakeholderBaseUrl)
}
export const deleteRoleItem = (token, stakeholderID, roleID) => {
    const entityName = getEntityName(stakeholderID)
    return deleteItem(entityName, roleID, token, stakeholderBaseUrl)
}
